import { HttpAxiosRequest } from "./httpAxiosRequest";

export type ClientReactErrorLog = {
    app: string;
    environment: string;
    url: string;
    path?: string;
    userAgent: string;
    timestampUtc: string;

    errorName: string;
    errorMessage: string;
    errorStack?: string | null;
    componentStack?: string | null;

    release?: string;

    // opcional: info adicional no sensible
    extra?: Record<string, any>;
};

// Throttle simple para no spamear si el error se dispara muchas veces
const lastSentByKey = new Map<string, number>();
const THROTTLE_MS = 60_000;

const shouldSend = (key: string) => {
    const now = Date.now();
    const last = lastSentByKey.get(key);
    if (last && now - last < THROTTLE_MS) return false;
    lastSentByKey.set(key, now);
    return true;
};

const normalize = (s?: string | null) =>
    (s ?? "").trim().slice(0, 12_000); // evita payloads gigantes

export const HttpLogger = {
    getEndpoint: (url: string) => `/logs${url}`,

    logReactError: async (payload: ClientReactErrorLog): Promise<void> => {
        const key = `${payload.errorMessage}__${payload.componentStack ?? ""}`.slice(0, 500);

        if (!shouldSend(key)) return;

        try {
            await HttpAxiosRequest.post<void>(HttpLogger.getEndpoint("/client-react-error"), {
                ...payload,
                errorMessage: normalize(payload.errorMessage),
                errorStack: normalize(payload.errorStack),
                componentStack: normalize(payload.componentStack),
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("HttpLogger.logReactError failed:", e);
        }
    },
};














